import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import AddInstalmentForm from './AddInstalmentForm';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import { withTranslation } from 'react-i18next';

class AddInstalmentDialog extends Component {
    dialogConfig() {
        const { t, onCancel } = this.props;

        return {
            header: t('PaymentHistory_AddInstalment'),
            body: this.renderBody(),
            onHide: onCancel,
            footer: this.renderFooter()
        };
    }

    renderBody() {
        const { onConfirm } = this.props;
        return <AddInstalmentForm onSubmit={onConfirm} />;
    }

    renderFooter() {
        const { onCancel, t } = this.props;

        const closeBtn = <Button key='close' onClick={onCancel}>{t('Common_Close')}</Button>;
        const confirmBtn = <RemoteSubmitButton key='save' style='primary' formName='addInstalment' label={t('PaymentHistory_AddInstalment')} />;
        return [closeBtn, confirmBtn];
    }

    render() {
        const { show, block, unblock } = this.props;
        const dialogConfig = this.dialogConfig();
        return <Dialog config={dialogConfig} show={show} block={block} unblock={unblock} />;
    }
}

AddInstalmentDialog.propTypes = {
    show: PropTypes.bool,
     block: PropTypes.oneOfType([
        PropTypes.instanceOf(RegExp),
        PropTypes.string,
        PropTypes.array,
        PropTypes.func
    ]),
    unblock: PropTypes.oneOfType([
        PropTypes.instanceOf(RegExp),
        PropTypes.string,
        PropTypes.array,
        PropTypes.func
    ]),
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired
};

export default withTranslation()(AddInstalmentDialog);